// Lib
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { describeElementTypes } from '../../../../../../common/notifications/notificationUtils';

// Selectors
import { areElementCountsInitialised } from '../../../../../app/initialisation/initialisationSelector';
import { contentLimitExceededSelector } from '../../../../../user/elementCount/elementCountSelector';

// Actions
import { fetchCurrentUserElementCounts } from '../../../../../user/currentUserActions';

// Components
import EllipsisAnimation from '../../../../../components/animations/EllipsisAnimation';

// Constants
import { isUnlimited } from '../../../../../../common/users/contentLimit';

// Styles
import './ElementCount.scss';

const mapStateToProps = createStructuredSelector({
    countsInitialised: areElementCountsInitialised,
    contentLimitExceeded: contentLimitExceededSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchElementCounts: () => dispatch(fetchCurrentUserElementCounts()),
});

const ElementCount = (props) => {
    const {
        contentTotalLimit,
        contentLimitExceeded,
        countsInitialised,
        shouldFetchCounts,
        showCountDetail,
        contentTotalCount,
        elementCount,
        dispatchFetchElementCounts,
    } = props;

    useEffect(() => {
        if (shouldFetchCounts) {
            dispatchFetchElementCounts();
        }
    }, []);

    if (isUnlimited(contentTotalLimit)) return null;

    if (!countsInitialised) {
        return (
            <div className="ElementCount">
                <div className="content-explain">
                    Loading counts
                    <EllipsisAnimation />
                </div>
                {contentLimitExceeded ? (
                    <progress value={1} max={1} className="full" />
                ) : (
                    <progress value={0} max={0} />
                )}
            </div>
        );
    }

    const isFull = contentTotalCount >= contentTotalLimit;
    const countDetail = showCountDetail ? describeElementTypes(elementCount.toJS()) : '';

    return (
        <div className="ElementCount">
            <progress value={contentTotalCount} max={contentTotalLimit} className={classNames({ full: isFull })} />

            <div className="content-explain">
                <span className="count-detail">
                    {contentTotalCount} / {contentTotalLimit} used
                </span>
                {countDetail.length > 0 && (
                    <>
                        {' '}
                        <span className="count-detail">({countDetail})</span>
                    </>
                )}
            </div>
        </div>
    );
};

ElementCount.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    elementCount: PropTypes.object,
    contentTotalCount: PropTypes.number,
    contentTotalLimit: PropTypes.number,
    showCountDetail: PropTypes.bool,
    countsInitialised: PropTypes.bool,
    contentLimitExceeded: PropTypes.bool,
    shouldFetchCounts: PropTypes.bool,
    dispatchFetchElementCounts: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ElementCount);
